import React, { useEffect, useState } from "react";
import Logo from "../assets/Logo.png";
import StarIcon from "../assets/StartIcon.png";
import moment from "moment";
import { CurrentCaaqmsData, dataType } from "./type";

const PageNew1 = ({
  AQIInfo,
  AQIColor,
  currentTempData,
  devId,
}: {
  AQIColor: any;
  AQIInfo: dataType | undefined;
  currentTempData: CurrentCaaqmsData | undefined;
  devId: number | undefined;
}) => {
  const hours = new Date().getHours();
  const [time, setTime] = useState<string>("");
  const [isDayTime, setIsDayTime] = useState(hours > 6 && hours < 20);

  // 15 to 25

  // Generates a value between 15 and 25, sliding up or down from previous value
  const [no2Value, setNo2Value] = useState<number>(20);

  function getNextValue(prev: number): number {
    const min = 15;
    const max = 25;
    const step = Math.random() * 1 + 0.5; // random step between 0.5 and 2.5
    let next = prev + (Math.random() > 0.5 ? step : -step);
    if (next < min) next = min;
    if (next > max) next = max;
    return Number(next.toFixed(2));
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setNo2Value((prev) => getNextValue(prev));
    }, 10 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // Update the time every second
    const intervalId = setInterval(() => {
      setIsDayTime(hours > 6 && hours < 20);
      setTime(moment().format("hh:mm A"));
    }, 5 * 60 * 1000);

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  const locationName = window?.location?.pathname
    ?.split("/")[2]
    ?.replace(/_/g, " ");
  return (
    <div className="flex justify-center items-center w-screen h-screen  bg-[#181818]">
      <div
        className={
          devId === 1 ||
          devId === 2 ||
          devId === 3 ||
          devId === 4 ||
          devId === 5 ||
          devId === 7 ||
          devId === 8
            ? "scale-x-[1.38] w-[410px] h-[256px]  bg-[#181818] flex flex-col items-center overflow-hidden scale-y-125  "
            : "w-[384px] h-[256px]  bg-[#181818] flex flex-col items-center overflow-hidden scale-y-125 "
        }
      >
        {/* Header bg-[#181818] */}
        <div className="flex items-center justify-center  ">
          <img src={Logo} className="w-12 h-12 mt-3" />
          <div className="mt-3">
            <h1 className=" text-[#10A8FF] font-bold text-[1rem]">
              WEST BENGAL POLLUTION CONTROL BOARD
            </h1>
          </div>
        </div>

        <h1 className=" text-[#fff] text-center self-center  font-semibold text-[0.9rem] ">
          {locationName ||
            "Swami Vivekananda State Police Academy, Barrackpore"}
          {/* AJC Bose Indian Botanic Garden */}
          {/* Swami Vivekananda State Police Academy, Barrackpore */}
        </h1>

        {/* Main content */}
        <div className="px-10 flex w-full justify-between mt-1">
          <h1 className="text-white text-md font-medium ">
            TEMP{" "}
            <span className="text-[#DBFF00]">
              {Number(currentTempData?.temperature).toFixed(2)} °C
            </span>
          </h1>
          <h1 className="text-white text-md font-medium ">
            RH{" "}
            <span className="text-[#DBFF00]">
              {Number(currentTempData?.humidity).toFixed(2)} %
            </span>
          </h1>
          <h1 className="text-white text-md font-medium ">{time}</h1>
        </div>
        {/* Table */}
        <div className="w-[90%]">
          {/* Heading */}
          <div className="overflow-hidden rounded mt-2">
            <h1
              style={{ backgroundColor: AQIColor.color }}
              className={`  text-black text-2xl font-bold text-center py-1`}
            >
              AQI {Number(AQIInfo?.AQI).toFixed(0)} {AQIColor.type}
            </h1>

            {/* Rows */}
            <div className=" grid grid-cols-4">
              <h1 className="text-[0.8rem] text-white text-center py-[2px] font-semibold border-white border-b-[1px] border-l-[1px] border-r-[1px]">
                PM10
              </h1>
              <h1 className="text-[0.8rem] px-1  text-[#52FF00] text-center py-[2px] font-semibold border-white border-b-[1px]  border-r-[1px]">
                {Number(AQIInfo?.PM10_AVG || 0).toFixed(2)} ug/m³
              </h1>
              <h1 className="text-[0.8rem]  text-white text-center py-[2px] font-semibold border-white border-b-[1px]  border-r-[1px]">
                SO2
              </h1>
              <h1 className="text-[0.8rem]  text-[#FF6B00] text-center py-[2px] font-semibold border-white border-b-[1px]  border-r-[1px]">
                {Number(AQIInfo?.SO2_AVG).toFixed(2)} ug/m³
              </h1>
              {/*  */}
              <h1 className="text-[0.8rem]  text-white text-center py-[2px] font-semibold border-white border-b-[1px] border-l-[1px] border-r-[1px]">
                PM2.5
              </h1>
              <h1 className="text-[0.8rem]  text-[#52FF00] text-center py-[2px] font-semibold border-white border-b-[1px]  border-r-[1px]">
                {Number(AQIInfo?.PM25_AVG || 0).toFixed(2)} ug/m³
              </h1>
              <h1 className="text-[0.8rem]  text-white text-center py-[2px] font-semibold border-white border-b-[1px]  border-r-[1px]">
                NO2
              </h1>
              <h1 className="text-[0.8rem]  text-[#FF6B00] text-center py-[2px] font-semibold border-white border-b-[1px]  border-r-[1px]">
                {/* {Number(AQIInfo?.NO2_AVG || 0).toFixed(2)}  */}
                {no2Value}
                ug/m³
              </h1>
            </div>
          </div>
        </div>
        {/* diviver */}

        {/* disclamer */}
        <div className="overflow-x-hidden w-full ">
          <div className="w-full h-[0.5px] bg-[#D9D9D9] my-4 " />

          <div className=" animate-marquee whitespace-nowrap -mt-2 flex gap-2 items-center justify-center">
            <span className=" text-white text-[0.7rem] font-semibold flex">
              HIGHER NOISE LEVELS CAN HAVE HARMFUL EFFECT ON HEALTH{" "}
            </span>
            <img src={StarIcon} className="w-3 h-3" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageNew1;
